import { useEffect } from 'react';

import { Permissions } from '@cloud-wave/neon-common-lib';

import { usePermissionsContext } from '../../PermissionsContext';
import { ISoftphoneModalOptionsProps, useSoftphoneModalContext } from '../../SoftphoneModalContext';
import { useAgentPreferencesContext } from '../Context';
import MyLocationForm from './MyLocationForm';
import { hasBeen90DaysSinceUpdated } from './utils/hasBeen90DaysSinceUpdated';

export default function MyLocationModal({
  setMyLocationModalOpened,
  myLocationModalOpened,
}: {
  setMyLocationModalOpened: (value: boolean) => void;
  myLocationModalOpened: boolean;
}) {
  const { hasPermission } = usePermissionsContext();

  const {
    state: { agentPreference },
  } = useAgentPreferencesContext();

  const {
    actions: { openModal, closeModal },
  } = useSoftphoneModalContext();

  const addLocationModalOptions: ISoftphoneModalOptionsProps = {
    title: 'Emergency Call Information',
    content: <MyLocationForm closeModal={closeModal} />,
    subtitle:
      'Your administrator has enabled enhanced emergency calling to include additional data in outbound emergency calls.',
    closeDisabled: true,
  };

  useEffect(() => {
    //Stop the modal from popping when data is being fetched or E911 is disabled in preferences
    if (!agentPreference.userId || agentPreference.e911Disabled) {
      return;
    }

    const hasE911Permission = hasPermission({ type: 'tenant', permission: Permissions.ENHANCED_EMERGENCY_CALLING });

    const hasMissingInformation =
      hasE911Permission &&
      (!agentPreference.location || !agentPreference.callbackNumber || !agentPreference.e911UpdatedTimestamp);

    const needsE911Update = hasE911Permission && hasBeen90DaysSinceUpdated(agentPreference.e911UpdatedTimestamp);

    const shouldOpenModal = !myLocationModalOpened && (hasMissingInformation || needsE911Update);

    if (shouldOpenModal) {
      openModal(addLocationModalOptions);
      setMyLocationModalOpened(true);
    }
  }, [agentPreference]);

  return null;
}
